import { render } from "./authentication.vue?vue&type=template&id=e4a63864"
import script from "./authentication.vue?vue&type=script&lang=js"
export * from "./authentication.vue?vue&type=script&lang=js"

import "./authentication.vue?vue&type=style&index=0&id=e4a63864&lang=scss"

import exportComponent from "/Users/a/Documents/work/new/prnew/lk-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__